import { GooglePrediction } from '@rbilabs/components-library';

import { GenericPrediction } from './types';

export const googlePredictionMapper = (prediction: GenericPrediction): GooglePrediction => {
  return {
    id: prediction.place_id,
    description: prediction.description || '',
    mainText: prediction.structured_formatting?.main_text || '',
    secondaryText: prediction.structured_formatting?.secondary_text || '',
  };
};
